import { clearChainProductDetails, clearMultiChainSortiment, clearSelectedProducts, editMultiChainFilter, editSelectedProduct, exportCsv, getInvoiceGroups, getNewChainProducts, loadChains, loadMoreMultiChainSortiment, prepareQueryOptions } from "../actions/multiChainSortiment";
import { createBoundFunction, createReselector } from "../../common/util/reselect.js";
import { setDropDown, setModal } from "../../common/actions/modal";

import MultiChainPage from "../components/MultiChainPage.jsx";
import { connect } from "react-redux";
import { createFlowControl } from "../../common/util/flowControl";
import { createLocalization } from "../../common/util/localization.jsx";
import { scssVariables } from "../../common/util/config.jsx";

const mapStateToProps = () => {
    const flowControl = createFlowControl();
    const flowControlCounter = createFlowControl();

    const userChainReselector = createReselector((chainIds, chains) => {
        const userChains = [...chainIds.map(id => chains[id]).filter(c => c)];
        userChains.sort((a, b) => a.chainName.localeCompare(b.chainName));
        return userChains;
    });

    return (state) => ({
        chains: state.multiChainSortiment.chains,
        deviceType: state.view.deviceType,
        flowControl: flowControl,
        flowControlCounter: flowControlCounter,
        height: state.view.innerHeight - parseInt(scssVariables.menuHeight),
        localization: createLocalization(state),
        multiChainSortiment: state.multiChainSortiment,
        userChains: userChainReselector(state.authentication.chainIds, state.multiChainSortiment.chains),
        width: state.view.innerWidth,
    });
};

const mapDispatchToProps = {
    clearChainProductDetails,
    clearMultiChainSortiment,
    editMultiChainFilter,
    getNewChainProducts,
    loadMoreMultiChainSortiment,
    prepareQueryOptions,
    setModal,
    setDropDown,
    loadChains,
    editSelectedProduct,
    clearSelectedProducts,
    getInvoiceGroups,
    exportCsv,
};

const myLoadMoreMultiChainSortiment = createBoundFunction();
const myEditMultiChainFilter = createBoundFunction();

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...stateProps,
    ...dispatchProps,
    ...ownProps,
    loadMoreMultiChainSortiment: myLoadMoreMultiChainSortiment((noOfProducts) => dispatchProps.loadMoreMultiChainSortiment(stateProps.multiChainSortiment, stateProps.productImage, noOfProducts)),
    editMultiChainFilter: myEditMultiChainFilter((change) => dispatchProps.editMultiChainFilter(change,
        myLoadMoreMultiChainSortiment((noOfProducts) => dispatchProps.loadMoreMultiChainSortiment(stateProps.multiChainSortiment, stateProps.productImage, noOfProducts))
    )),
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(MultiChainPage);
